export const CHUNK_SIZE = 16;
export const CHUNK_HEIGHT = 128;
export const SEA_LEVEL = 46;
export const VIEW_DISTANCE = 6;
export const UNLOAD_PADDING = 2;

export const PLAYER_HEIGHT = 1.72;
export const PLAYER_RADIUS = 0.3;
export const EYE_HEIGHT = 1.54;
export const STEP_HEIGHT = 0.55;

export const WALK_SPEED = 4.7;
export const SNEAK_SPEED = 1.6;
export const SPRINT_SPEED = 6.5;
export const FLY_SPEED = 16;
export const SWIM_SPEED = 3.1;
export const JUMP_VELOCITY = 8.6;
export const GRAVITY = 28;
export const WATER_GRAVITY = 7;
export const FLY_VERTICAL = 10;

export const MOUSE_SENS = 0.00215;
export const THIRD_PERSON_DIST = 4.8;
export const THIRD_PERSON_HEIGHT = 1.35;

export const DAY_LENGTH = 520;
export const MAX_HEALTH = 20;
export const MAX_HUNGER = 20;
export const MAX_ARMOR = 20;

export const HOTBAR_SIZE = 9;
export const INV_SIZE = 27;
export const ARMOR_SLOTS = 4;

export const WORLD_VERSION = 1;
export const SAVE_KEY = "cubeholt-world-v1";

export const CHUNK_VOLUME = CHUNK_SIZE * CHUNK_HEIGHT * CHUNK_SIZE;
